import React from 'react';
import { history } from 'umi';
import './styles.less';



export default (props) => {

  const { data } = props;

  return (
    <div className='item_box'
         onClick={() =>{
           history.push('/home/courseDetail?courseId=' + data.courseId + '&title=' + data.course.name);

         }}
    >
      <div className='imgBox'>
        <img className='item_img' alt='' src={data.course.image}/>
        {data.course.type !== '3' && <img className='item_play'
                                          src={data.course.type == '1' ? require('@/assets/ic_play.png') : require('@/assets/music_play.png')}/>}
      </div>
      <div className='item_content'>
        <label className='item_title'>{data.course.name}</label>
        <label className='item_subtitle'>{data.courseDirectory.hourName + ' ' + data.courseDirectory.directoryName}</label>
        <label className='item_use'>消耗果实：{data.consumeFruit}</label>
      </div>
    </div>
  )

}


